import Storage from "@/core/services/storage";
// import { theme } from "ant-design-vue";
export type ThemeConfig = {
  themeConfig: any;
  themeName: string;
  systemName: string;
  mobile: string;
};
export default {
  namespaced: true,
  state: {
    themeConfig: {
      // algorithm: theme.defaultAlgorithm,
      token: {
        borderRadius: 2,
      },
    }, // 主题色
    themeName: "default",
    systemName:'合伙人 1号',
    mobile:'18221394480'
  },
  mutations: {
    SET_themeConfig: function (state, obj) {
      state.themeConfig.token = Object.assign(state.themeConfig.token, obj);
    },
    SET_themeName: function (state, name) {
      state.themeName = name;
      document.documentElement.setAttribute("data-theme", state.themeName);
    },
    SET_systemName: function (state, systemName) {
      state.systemName = systemName
    },
    SET_mobile: function (state, mobile) {
      state.mobile = mobile
    },
  },
  actions: {},
  getters: {},
};
